import React from "react";
import { Link } from "react-router-dom";

export function Home() {
  const highlights = [
    { number: "99.9%", label: "Cloud Uptime & Reliability" },
    { number: "100%", label: "Client-Centric Solutions" },
    { number: "10x", label: "Workflow Efficiency Through Automation" },
    { number: "24/7", label: "Dedicated Support & Monitoring" }
  ];

  const services = [
    {
      icon: "☁️",
      title: "Cloud Services & Infrastructure",
      desc: "Robust cloud strategy, migration, and infrastructure management across AWS, Azure, and GCP for high availability.",
      tags: ["Cloud Migration", "DevOps & CI/CD", "Serverless", "Security"]
    },
    {
      icon: "📱",
      title: "Web & Mobile Application Development",
      desc: "Custom-built, scalable enterprise applications with modern frameworks like React, Node.js, and native mobile stacks.",
      tags: ["Full Stack", "React", "Mobile Apps", "Microservices"]
    },
    {
      icon: "⚡",
      title: "Intelligent Workflow Automation",
      desc: "Automating repetitive business processes and manual operations to maximize speed, minimize error, and lower costs.",
      tags: ["RPA", "Process Automation", "API Integration", "Efficiency"]
    },
    {
      icon: "👥",
      title: "Strategic IT Consulting & Talent",
      desc: "Access specialized technical talent and advisory consulting to accelerate product roadmaps and strategic initiatives.",
      tags: ["Talent Solutions", "Architecture Advisory", "Staff Augmentation"]
    }
  ];

  const features = [
    {
      icon: "🛡️",
      title: "Enterprise Grade Reliability",
      desc: "Engineered for maximum security, continuous availability, and stringent regulatory compliance standards."
    },
    {
      icon: "🚀",
      title: "Rapid Time-to-Value",
      desc: "Agile sprints and proven engineering blueprints that move your project from concept to production quickly."
    },
    {
      icon: "💡",
      title: "Innovative & Scalable",
      desc: "Architectures designed to scale seamlessly with your growing traffic, user base, and data volumes."
    },
    {
      icon: "🤝",
      title: "Dedicated Partnership",
      desc: "We work directly alongside your stakeholders as an extension of your team, ensuring transparency and accountability."
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="badge">
              <span>●</span> Modern IT Consulting & Cloud Engineering
            </div>
            <h1 className="hero-title">
              Empowering Enterprises with <span>Cloud Innovation</span> & <span>Intelligent Automation</span>
            </h1>
            <p className="hero-subtitle">
              Advanced Cloudlink Technologies delivers high-quality, client-centric software solutions,
              cloud modernization, and process automation to solve complex business challenges.
            </p>
            <div className="hero-actions">
              <Link to="/services" className="btn-primary">
                Explore Our Services →
              </Link>
              <Link to="/contact" className="btn-outline">
                Contact Our Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Ribbon */}
      <div className="stats-ribbon">
        <div className="container">
          <div className="stats-grid">
            {highlights.map((h, i) => (
              <div key={i} className="stat-item">
                <span className="stat-number">{h.number}</span>
                <span className="stat-label">{h.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Core Capabilities</span>
            <h2 className="section-title">What We Do Best</h2>
            <p className="section-desc">
              From enterprise web applications to cloud infrastructure and workflow automation, we engineer solutions that elevate your business.
            </p>
          </div>

          <div className="cards-grid">
            {services.map((s, idx) => (
              <div key={idx} className="service-card">
                <div className="service-icon-box">{s.icon}</div>
                <h3 className="service-title">{s.title}</h3>
                <p className="service-text">{s.desc}</p>
                <div className="service-tags">
                  {s.tags.map((tag, tIdx) => (
                    <span key={tIdx} className="pill">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section features-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">The ACT Advantage</span>
            <h2 className="section-title">Why Leading Companies Partner With ACT</h2>
            <p className="section-desc">
              We combine deep technical mastery with proactive client commitment to deliver measurable outcomes.
            </p>
          </div>

          <div className="features-grid">
            {features.map((f, i) => (
              <div key={i} className="feature-item">
                <div className="feature-icon">{f.icon}</div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>

          {/* Consultation CTA Banner */}
          <div className="cta-banner">
            <h2>Ready to transform your business operations?</h2>
            <p>
              Partner with Advanced Cloudlink Technologies Inc for custom IT solutions and scalable cloud infrastructure.
            </p>
            <Link to="/contact" className="btn-white">
              Schedule a Consultation →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
